/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	window.Breakout = __webpack_require__(1);

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(2);

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var Phaser = __webpack_require__(3);
	
	var State = __webpack_require__(4);
	
	var WIDTH = 320;
	var HEIGHT = 360;
	
	var Game = function Game(parent) {
	    _classCallCheck(this, Game);
	
	    this.game = new Phaser.Game(WIDTH, HEIGHT, Phaser.AUTO, parent, null, false, false);
	    this.game.state.add('boot', new State.Boot(), true);
	    this.game.state.add('menu', new State.Menu());
	    this.game.state.add('game', new State.Game());
	};
	
	module.exports = Game;

/***/ }),
/* 3 */
/***/ (function(module, exports) {

	module.exports = Phaser;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = {
	    Boot: __webpack_require__(5),
	    Game: __webpack_require__(6),
	    Menu: __webpack_require__(10)
	};

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var Phaser = __webpack_require__(3);
	
	var Boot = (function () {
	    function Boot() {
	        _classCallCheck(this, Boot);
	    }
	
	    _createClass(Boot, [{
	        key: 'preload',
	        value: function preload() {
	            this.game.stage.disableVisibilityChange = true;
	            this.game.scale.scaleMode = Phaser.ScaleManager.SHOW_ALL;
	            this.game.scale.pageAlignHorizontally = true;
	        }
	    }, {
	        key: 'create',
	        value: function create() {
	            this.game.state.start('game');
	        }
	    }]);
	
	    return Boot;
	})();
	
	module.exports = Boot;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var Phaser = __webpack_require__(3);
	
	var Objects = __webpack_require__(7);
	
	var BRICK_COLUMN_COUNT = 8;
	var BRICK_ROW_COUNT = 16;
	var BRICK_ROW_MARGIN = 5;
	var HIT_BALL_SCALE = 10;
	var BRICK_NAMES = ['blue_brick', 'orange_brick', 'pink_brick', 'green_brick'];
	
	var Game = (function () {
	    function Game() {
	        _classCallCheck(this, Game);
	    }
	
	    _createClass(Game, [{
	        key: 'preload',
	        value: function preload() {
	            this.load.image('paddle', 'img/paddle.png');
	            this.load.image('ball', 'img/ball.png');
	            for (var i = 0; i < BRICK_NAMES.length; i++) {
	                var brickName = BRICK_NAMES[i];
	                this.load.image(brickName, 'img/' + brickName + '.png');
	            }
	        }
	    }, {
	        key: 'create',
	        value: function create() {
	            this.game.physics.startSystem(Phaser.Physics.ARCADE);
	            this.game.physics.arcade.checkCollision.down = false;
	
	            this.paddle = new Objects.Paddle(this.game, 0, this.game.height);
	            this.game.add.existing(this.paddle);
	
	            this.ball = new Objects.Ball(this.game, this.game.width / 2, this.game.height / 2);
	            this.game.add.existing(this.ball);
	
	            this.bricks = this.game.add.physicsGroup();
	            var tempBrickImage = this.cache.getImage(BRICK_NAMES[0]);
	            var totalBrickWidth = tempBrickImage.width * BRICK_COLUMN_COUNT;
	            var brickMargin = (this.game.width - totalBrickWidth) / 2;
	            var brick = undefined;
	            for (var x = 0; x < BRICK_COLUMN_COUNT; x++) {
	                for (var y = 0; y < BRICK_ROW_COUNT; y++) {
	                    brick = this.bricks.create(brickMargin + x * tempBrickImage.width, BRICK_ROW_MARGIN * tempBrickImage.height + y * tempBrickImage.height, 'pink_brick');
	                    brick.body.bounce.set(1);
	                    brick.body.immovable = true;
	                }
	            }
	
	            this.game.input.onDown.add(this.shootBall, this);
	        }
	    }, {
	        key: 'update',
	        value: function update() {
	            this.game.physics.arcade.collide(this.ball, this.paddle, this._ballCollidesWithPaddle);
	            this.game.physics.arcade.collide(this.ball, this.bricks, this._ballCollidesWithBrick, null, this);
	        }
	    }, {
	        key: 'shootBall',
	        value: function shootBall() {
	            if (this.ball.aiming) {
	                var dx = this.ball.x - this.paddle.x;
	                var dy = this.ball.y - this.paddle.y;
	                this.ball.shoot(dx, dy);
	            }
	        }
	    }, {
	        key: '_ballCollidesWithPaddle',
	        value: function _ballCollidesWithPaddle(ball, paddle) {
	            ball.body.velocity.x = (ball.x - paddle.x) * HIT_BALL_SCALE;
	        }
	    }, {
	        key: '_ballCollidesWithBrick',
	        value: function _ballCollidesWithBrick(ball, brick) {
	            brick.kill();
	
	            if (this.bricks.countLiving() === 0) {
	                this.game.state.restart();
	            }
	        }
	    }], [{
	        key: '_processBallBrickCollision',
	        value: function _processBallBrickCollision(ball, brick) {
	            var brickCenterX = brick.x + brick.width / 2;
	            var brickCenterY = brick.y + brick.height / 2;
	            var dx = Math.max(Math.abs(ball.x, brickCenterX) - brick.width / 2, 0);
	            var dy = Math.max(Math.abs(ball.x, brickCenterY) - brick.width / 2, 0);
	            var distance = Math.sqrt(dx * dx + dy * dy);
	            var radius = ball.width / 2;
	            return distance < radius;
	        }
	    }]);
	
	    return Game;
	})();
	
	module.exports = Game;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = {
	    'Ball': __webpack_require__(8),
	    'Paddle': __webpack_require__(9)
	};

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Phaser = __webpack_require__(3);
	
	// const SPEED = 100; // pixels per second
	var ANCHOR_X = 0.5;
	var ANCHOR_Y = 0.5;
	
	var Ball = (function (_Phaser$Sprite) {
	    _inherits(Ball, _Phaser$Sprite);
	
	    function Ball(game, initialX, initialY) {
	        _classCallCheck(this, Ball);
	
	        _get(Object.getPrototypeOf(Ball.prototype), 'constructor', this).call(this, game, initialX, initialY, 'ball');
	        this.game.physics.arcade.enable(this, Phaser.Physics.ARCADE);
	        this.body.bounce.set(1);
	        this.body.collideWorldBounds = true;
	        this.anchor.set(ANCHOR_X, ANCHOR_Y);
	        this.checkWorldBounds = true;
	        this.events.onOutOfBounds.add(this._outOfBounds, this);
	
	        this.aiming = true;
	        this.initialX = initialX;
	        this.initialY = initialY;
	    }
	
	    _createClass(Ball, [{
	        key: 'shoot',
	        value: function shoot(dx, dy) {
	            this.aiming = false;
	            this.body.velocity.set(dx, dy);
	        }
	    }, {
	        key: '_outOfBounds',
	        value: function _outOfBounds() {
	            this.x = this.initialX;
	            this.y = this.initialY;
	            this.body.velocity.set(0);
	            this.aiming = true;
	        }
	    }]);
	
	    return Ball;
	})(Phaser.Sprite);
	
	module.exports = Ball;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Phaser = __webpack_require__(3);
	
	var PADDLE_ANCHOR_X = 0.5;
	var PADDLE_ANCHOR_Y = 1.0;
	
	var Paddle = (function (_Phaser$Sprite) {
	    _inherits(Paddle, _Phaser$Sprite);
	
	    function Paddle(game, x, y) {
	        _classCallCheck(this, Paddle);
	
	        _get(Object.getPrototypeOf(Paddle.prototype), 'constructor', this).call(this, game, x, y, 'paddle');
	        this.anchor.set(PADDLE_ANCHOR_X, PADDLE_ANCHOR_Y);
	        game.physics.enable(this, Phaser.Physics.ARCADE);
	        this.body.bounce.set(1);
	        this.body.immovable = true;
	    }
	
	    _createClass(Paddle, [{
	        key: 'update',
	        value: function update() {
	            this.x = this.game.input.x;
	            var halfWidth = this.width / 2;
	            this.position.clampX(halfWidth, this.game.width - halfWidth);
	        }
	    }]);
	
	    return Paddle;
	})(Phaser.Sprite);
	
	module.exports = Paddle;

/***/ }),
/* 10 */
/***/ (function(module, exports) {

	'use strict';
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var Menu = (function () {
	    function Menu() {
	        _classCallCheck(this, Menu);
	    }
	
	    _createClass(Menu, [{
	        key: 'preload',
	        value: function preload() {
	            this.load.image('play', 'img/play.png');
	        }
	    }, {
	        key: 'create',
	        value: function create() {
	            this.start = this.add.button(0, 0, 'play', this.play, this);
	        }
	    }, {
	        key: 'play',
	        value: function play() {
	            this.state.start('game');
	        }
	    }]);
	
	    return Menu;
	})();
	
	module.exports = Menu;

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// breakout.min.js